module.exports = __webpack_public_path__ + "img/ic_mail.477edc35.svg";